import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAssetHierarchyAPI } from '../api/assetHierarchy.api';

export const getAssetHierarchy = createAsyncThunk(
  'assetHierarchy/getAssetHierarchy',
  async (_, thunkAPI) => {
    try {
      const response = await getAssetHierarchyAPI();
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
